export const CashBox = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2547_12560)'>
        <g clipPath='url(#clip1_2547_12560)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.7121 3.03711C16.9104 3.03711 17.8899 3.9738 17.9583 5.1549L17.9621 5.28711V13.9121C17.9621 15.1104 17.0254 16.0899 15.8443 16.1583L15.7121 16.1621H2.28711C1.08885 16.1621 0.109364 15.2254 0.0409289 14.0443L0.0371094 13.9121V5.28711C0.0371094 4.08885 0.973799 3.10936 2.1549 3.04093L2.28711 3.03711H15.7121ZM15.7121 4.16211H2.28711C1.70234 4.16211 1.22177 4.60828 1.16726 5.17876L1.16211 5.28711V13.9121C1.16211 14.4969 1.60828 14.9774 2.17876 15.032L2.28711 15.0371H15.7121C16.2969 15.0371 16.7774 14.5909 16.832 14.0205L16.8371 13.9121V5.28711C16.8371 4.70234 16.3909 4.22177 15.8205 4.16726L15.7121 4.16211ZM12.3011 10.0211L12.3587 9.98116C12.6854 9.76378 13.0777 9.63711 13.4996 9.63711C14.6387 9.63711 15.5621 10.5605 15.5621 11.6996C15.5621 12.8387 14.6387 13.7621 13.4996 13.7621C13.0523 13.7621 12.6383 13.6197 12.3004 13.3779C11.7727 13.7587 11.0825 13.8757 10.4409 13.6629C9.59478 13.3823 9.02362 12.5911 9.02362 11.6996C9.02362 10.8081 9.59478 10.0169 10.4409 9.73628C11.0367 9.5387 11.6743 9.62547 12.1855 9.94357L12.3011 10.0211ZM10.7951 10.8041C10.4091 10.9321 10.1486 11.293 10.1486 11.6996C10.1486 12.1062 10.4091 12.4671 10.7951 12.5951C11.0696 12.6862 11.3637 12.6448 11.5981 12.496C11.4938 12.2506 11.4371 11.9817 11.4371 11.6996C11.4371 11.4175 11.4938 11.1486 11.5963 10.9037C11.3637 10.7544 11.0696 10.713 10.7951 10.8041ZM13.4996 10.7621C12.9818 10.7621 12.5621 11.1818 12.5621 11.6996C12.5621 12.2174 12.9818 12.6371 13.4996 12.6371C14.0174 12.6371 14.4371 12.2174 14.4371 11.6996C14.4371 11.1818 14.0174 10.7621 13.4996 10.7621ZM5.39961 11.4371C5.71027 11.4371 5.96211 11.6889 5.96211 11.9996C5.96211 12.2844 5.75049 12.5197 5.47594 12.557L5.39961 12.5621H2.99961C2.68895 12.5621 2.43711 12.3103 2.43711 11.9996C2.43711 11.7148 2.64872 11.4795 2.92328 11.4422L2.99961 11.4371H5.39961ZM5.39961 5.43711C5.68438 5.43711 5.91973 5.64873 5.95697 5.92328L5.96211 5.99961V8.39961C5.96211 8.68438 5.75049 8.91973 5.47594 8.95697L5.39961 8.96211H2.99961C2.71484 8.96211 2.47949 8.75049 2.44224 8.47594L2.43711 8.39961V5.99961C2.43711 5.71484 2.64872 5.47949 2.92328 5.44224L2.99961 5.43711H5.39961ZM4.83711 6.56136H3.56136V7.83711H4.83711V6.56136Z'
            fill='currentColor'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_2547_12560'>
          <rect
            width='18'
            height='18'
            fill='white'
          />
        </clipPath>
        <clipPath id='clip1_2547_12560'>
          <rect
            width='18'
            height='18'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
